import React from 'react';
import {View, Image, StyleSheet, Text} from 'react-native';

const TitleBlock = ({textColor, bgColor, children, image}) => {
  return (
    <View style={[styles.container, {backgroundColor: bgColor}]}>
      <Text style={[styles.text, {color: textColor}]}>{children}</Text>
      <Image style={styles.img} source={image} />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: '100%',
    height: 100,
    justifyContent: 'center',
    overflow: 'hidden',
  },
  text: {
    width: '80%',
    padding: 20,
    fontFamily: 'Roboto-Bold',
    fontSize: 20,
  },
  img: {
    position: 'absolute',
    right: -12,
    bottom: -11,
  },
});

export default TitleBlock;
